exports.f = {}.propertyIsEnumerable;



//////////////////
// WEBPACK FOOTER
// /Users/gtirby/develop/~/core-js/library/modules/_object-pie.js
// module id = 79
// module chunks = 0